import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { PageResponse } from '@models/api';
import { getUsers, type GetUsersParams } from '@apis/users';
import type { User } from '@models/user';
import { dropEmptyValues } from '@utils/common';

type UseUserListArgs = {
  page: number;
  pageSize: number;
  searchParam: GetUsersParams;
};

export const useUserList = ({ page, pageSize, searchParam }: UseUserListArgs) => {
  const cleaned = dropEmptyValues(searchParam, ['username', 'name', 'group', 'status']);

  const queryOptions: UseQueryOptions<PageResponse<User>, Error> = {
    queryKey: ['users', page, pageSize, cleaned],
    queryFn: () =>
      getUsers({
        pageNo: page,
        pageSize,
        ...cleaned,
      }),
    enabled: page > 0 && pageSize > 0,
    refetchOnMount: 'always',
  };

  return useQuery(queryOptions);
};
